module.exports = __webpack_public_path__ + "img/indexLogo.9317b5af.png";